export default __webpack_public_path__ + "static/media/prev.c0d03b29.svg";